import { StyledErrorContainer } from './ErrorFallback.styled';

interface ErrorFallbackProps {
  error?: Error;
  resetError?: () => void;
}

export const ErrorFallback = ({ error, resetError }: ErrorFallbackProps) => (
  <StyledErrorContainer>
    <h2>Что-то пошло не так</h2>
    {error && <p>{error.message}</p>}
    {resetError && <button onClick={resetError}>Попробовать снова</button>}
  </StyledErrorContainer>
);
